import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { EmissionPoint } from 'src/app/modelo/EmissionPoint';
import { EstablismentSecuencia } from 'src/app/modelo/EstablismentSecuencia';
import { SecuenciasData } from 'src/app/modelo/SecuenciasData';
import { environment } from 'src/environments/environment';
import { ApiService } from '../../core';
import { HandleError, HttpErrorHandler } from '../../http-error-handler.service';
import { Establishment } from '../../modelo/Establishment';

@Injectable({
    providedIn: 'root'
})
export class EstablecimientosService {
    private apiServer = '';
    private handleError: HandleError;

    constructor(
        private apiService: ApiService,
        private httpErrorHandler: HttpErrorHandler
    ) {
        this.apiServer = environment.settings.apiServer;
        this.handleError = httpErrorHandler.createHandleError('EstablecimientosService');
    }

    /*************************************************************************************
     **REQUEST HTTP
     **************************************************************************************/
    async getEstablishmentsPorOrganizacionData(): Promise<any> {
        return this.getEstablishmentsPorOrganizacion().toPromise();
    }
    getEstablishmentsPorOrganizacion() {
        return this.apiService.get(this.apiServer + '/organization/establishments')
            .pipe(
                catchError(this.handleError('EstablecimientosService.getEstablishmentsPorOrganizacion'))
            )
    }
    /*************************************************************************************
     **REQUEST HTTP
     **************************************************************************************/
    async getEstablishmentsPorOrganizacionTipoComprobanteData(tipoComprobante:string): Promise<any> {
        return this.getEstablishmentsPorOrganizacionTipoComprobante(tipoComprobante).toPromise();
    }
    getEstablishmentsPorOrganizacionTipoComprobante(tipoComprobante:string) {
        return this.apiService.get(this.apiServer + '/organization/establishments/' + tipoComprobante)
            .pipe(
                catchError(this.handleError('EstablecimientosService.getEstablishmentsPorOrganizacion'))
            )
    }
    async getPuntoEmisionSecuenciasData(estab:string, ptoEmi:string, tipoComprobante:string): Promise<any> {
        return this.getPuntoEmisionSecuencias(estab, ptoEmi, tipoComprobante).toPromise();
    }
    getPuntoEmisionSecuencias(estab:string, ptoEmi:string, tipoComprobante:string) {
        return this.apiService.get(`${this.apiServer }/organization/establecimiento/${estab}/punto/${ptoEmi}/secuencia/${tipoComprobante}`)
            .pipe(
                catchError(this.handleError('EstablecimientosService.getEstablishmentsPorOrganizacion'))
            )
    }

    enviarEstablecimiento(establishment: Establishment) {
        if (establishment.id && establishment.uuid) {
            return this.apiService
                .put(this.apiServer + '/organization/establishment', establishment)
                .pipe(map((data) => data['establishment']));
        } else {
            return this.apiService
                .post(this.apiServer + '/organization/establishment', establishment)
                .pipe(map((data) => data['establishment']));
        }
    }

    cargarEstablismentSecuencia(establishment: Establishment) {
        if (establishment.id && establishment.uuid) {
            return this.apiService
                .put(this.apiServer + '/organization/establishment/secuencias', establishment)
                .pipe(map((data) => data['establishment']));
        }
    }

    updateSecuenciasEstablishment(establismentSecuencia: EstablismentSecuencia) {
        return this.apiService
            .put(this.apiServer + '/organization/establishment/serial', establismentSecuencia)
            .pipe(map((data) => data['establishment']));
    }

    async getEmissionPointsPorEstablishmentData(establishmentId: number): Promise<any> {
        return this.getEmissionPointsPorEstablishment(establishmentId).toPromise();
    }
    getEmissionPointsPorEstablishment(establishmentId: number) {
        return this.apiService.get(this.apiServer + '/organization/establishment/' + establishmentId + "/emissionpoints")
            .pipe(
                catchError(this.handleError('EstablecimientosService.getEmissionPointsPorEstablishment'))
            )
    }

    enviarPuntoDeEmision(emissionPoint: EmissionPoint) {
        if (emissionPoint.id && emissionPoint.uuid) {
            return this.apiService
                .put(this.apiServer + '/organization/establishment/emissionpoint', emissionPoint)
                .pipe(map((data) => data['emissionPoint']));
        } else {
            return this.apiService
                .post(this.apiServer + '/organization/establishment/emissionpoint', emissionPoint)
                .pipe(map((data) => data['emissionPoint']));
        }
    }

    borrarEmissionPoint(uuid: string): Observable<EmissionPoint> {
        return this.apiService.delete(this.apiServer + '/organization/establishment/emissionpoint/' + uuid)
            .pipe(
                catchError(this.handleError('EstablecimientosService.borrarEmissionPoint', uuid)))
    }

    /**   
    * Organization
    **/
    async getEstablecimientoImageData(uuid:string): Promise<any> {
        return this.getEstablecimientoImage(uuid).toPromise();
    }
    
    getEstablecimientoImage(uuid:string) {
        return this.apiService.get(this.apiServer + '/organization/establishment/' + uuid + '/image')
            .pipe(
                catchError(this.handleError('PerfilService.getUserOrganizationImage'))
            )
    }

}
